import styled from 'styled-components';
import { IStepperProps } from '../../../types/formTypes';

export const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
`;

export const StepperError = styled.div<Pick<IStepperProps, 'darkMode'>>`
  color: var(--base-color-${({ darkMode }) => (darkMode ? 'white' : 'errorstate')});
  margin-block: 15px 0;

  * {
    margin: 0;
  }
`;

export const StepperBox = styled.div<Pick<IStepperProps, 'error' | 'darkMode' | 'disabled'>>`
  width: 154px;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid
    var(
      --base-color-${({ darkMode, disabled, error }) => {
          if (error) return 'errorstate';
          if (disabled) return 'midgrey';
          if (darkMode) return 'darkgrey';
          return 'darkgrey';
        }}
    );
  background-color: var(--base-color-${({ disabled }) => (disabled ? 'lightgrey' : 'white')});
  ${({ error, darkMode }) => (error && darkMode ? 'outline: 1px solid var(--base-color-errorstate);' : '')};

  * {
    color: var(--base-color-${({ disabled }) => (disabled ? 'midgrey' : 'black')});
    word-break: unset;
    user-select: none;
  }

  path {
    fill: var(--base-color-${({ disabled }) => (disabled ? 'midgrey' : 'black')}) !important;
  }

  & > * {
    width: 51px;
  }
`;

export const StepperValue = styled.input<Pick<IStepperProps, 'disabled'>>`
  width: 51px;
  border: 0;
  text-align: center;
  font-family: var(--font-family-altHeader);
  font-size: var(--font-size-altHeader-6);
  font-weight: var(--font-weight-altHeader-6);
  background-color: transparent;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
`;

export const StepperButton = styled.div<Pick<IStepperProps, 'disabled'>>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  span {
    display: flex;
    justify-content: center;
  }

  svg {
    width: 40%;
    height: auto;
  }
`;
